import React, { useState, useEffect } from "react";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import Invoices from "./pages/Invoices";
import Users from "./pages/Users";
import Bookings from "./pages/Bookings";
import FlightBookings from "./pages/FlightBookings";
import HotelBookings from "./pages/HotelBookings";
import DashboardHome from "./pages/DashboardHome";
import Discounts from "./pages/Discounts";          // <-- import the new page
import "./styles/admin.css";

export type View =
  | "dashboard"
  | "invoices"
  | "users"
  | "bookings"
  | "flight_bookings"
  | "hotel_bookings"
  | "discounts";                                   // <-- add new view

const AdminDashboard: React.FC = () => {
  const [view, setView] = useState<View>("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(() => window.innerWidth >= 992);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth < 992) setSidebarOpen(false);
      else setSidebarOpen(true);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (window.innerWidth < 992) setSidebarOpen(false);
  }, [view]);

  const renderView = () => {
    switch(view) {
      case "dashboard": return <DashboardHome />;
      case "invoices": return <Invoices />;
      case "users": return <Users />;
      case "flight_bookings": return <FlightBookings />;
      case "hotel_bookings": return <HotelBookings />;
      case "bookings": return <Bookings />;
      case "discounts": return <Discounts />;       // <-- new case
      default: return <DashboardHome />;
    }
  };

  return (
    <div className="admin-root min-vh-100 bg-light d-flex text-dark">
      <Sidebar
        active={view}
        onChange={(v) => setView(v)}
        open={sidebarOpen}
        onRequestClose={() => setSidebarOpen(false)}
        onToggle={() => setSidebarOpen((s) => !s)}
      />

      <div className="flex-fill d-flex flex-column">
        <Topbar sidebarOpen={sidebarOpen} onToggleSidebar={() => setSidebarOpen(s => !s)} />

        <main className="p-4">
          <section>{renderView()}</section>
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;